/**
 * Форматирует числительные на русском языке
 * @param {Number} count - Количество
 * @param {Array} forms - Формы чилистельных для случаев "1", "2" и "несколько", например ["яблоко", "яблока", "яблок"]
 */

export const formatCount = (count, forms) => {
	const cases = [2, 0, 1, 1, 1, 2];
	return forms[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
};